// Module
var code = "<md-dialog class=\"cluster-edit-dialog\" layout=\"column\" aria-label=\"Edit Cluster\"> <planning-edit-clustering-area-view flex clustering-area=\"clusteringArea\" on-cancel=\"cancel()\" on-save=\"submit(clusteringArea)\"> </planning-edit-clustering-area-view> </md-dialog> ";
// Exports
export default code;